import Icon from '../components/Icon.vue'

Icon.register({
  eject: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 384v64c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32zM48.1 320c-41.7 0-63.5-49.7-35.4-80.4l175.9-192c19-20.7 51.8-20.7 70.8 0l175.9 192c28.2 30.8 6.3 80.4-35.4 80.4h-351.9z'
      }
    ]
  }
})
